'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _stringUtils = require('../../utils/stringUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function toString(value) {
	return value === null ? '' : String(value);
}

function toValue(string, options) {
	return string === '' ? null : options.reduce(function (acc, _ref) {
		var value = _ref.value;
		return String(value) === string ? value : acc;
	}, string);
}

var SelectInput = (_temp = _class = function (_Component) {
	_inherits(SelectInput, _Component);

	function SelectInput() {
		_classCallCheck(this, SelectInput);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SelectInput.prototype.componentDidUpdate = function componentDidUpdate() {
		if (this.props.coerceValueToOptions && this.props.value !== undefined) {
			this.coerceValueToOptions();
		}
	};

	SelectInput.prototype.coerceValueToOptions = function coerceValueToOptions() {
		// coerce value to defaultValue if value not found in options
		var _props = this.props,
		    value = _props.value,
		    defaultValue = _props.defaultValue,
		    empty = _props.empty;

		var options = this.normalisedOptions();
		var selectedOption = options.find(function (option) {
			return option.value === value;
		});
		if (!selectedOption) {
			if (options.length && empty === false) {
				// select first item if we have options to choose from
				// and we have an "empty" option
				this.props.onChange(options[0].value);
			} else if (value !== defaultValue) {
				// set value to defaultValue
				this.props.onChange(defaultValue);
			}
		}
	};

	SelectInput.prototype.normalisedOptions = function normalisedOptions() {
		return this.props.options.map(function (option) {
			return typeof option === 'string' ? { value: option, text: (0, _stringUtils.titleCase)(option) } : option;
		});
	};

	SelectInput.prototype.renderOptions = function renderOptions() {
		var empty = this.props.empty !== false && _react2.default.createElement(
			'option',
			{ value: toString(this.props.defaultValue), key: 0 },
			this.props.empty
		);
		var options = this.normalisedOptions().map(function (_ref2, i) {
			var value = _ref2.value,
			    text = _ref2.text;
			return _react2.default.createElement(
				'option',
				{ key: i + 1, value: value },
				text
			);
		});
		return empty ? [empty].concat(options) : options;
	};

	SelectInput.prototype.render = function render() {
		var _this2 = this;

		var _props2 = this.props,
		    options = _props2.options,
		    defaultValue = _props2.defaultValue,
		    empty = _props2.empty,
		    coerceValueToOptions = _props2.coerceValueToOptions,
		    readOnly = _props2.readOnly,
		    onChange = _props2.onChange,
		    value = _props2.value,
		    className = _props2.className,
		    rest = _objectWithoutProperties(_props2, ['options', 'defaultValue', 'empty', 'coerceValueToOptions', 'readOnly', 'onChange', 'value', 'className']);

		return _react2.default.createElement(
			'label',
			{ className: (0, _classnames2.default)('select', className) },
			_react2.default.createElement(
				'select',
				_extends({}, rest, {
					value: toString(value),
					disabled: readOnly,
					onChange: function onChange(event) {
						return _this2.props.onChange(toValue(event.target.value, _this2.normalisedOptions()));
					} }),
				this.renderOptions()
			)
		);
	};

	return SelectInput;
}(_react.Component), _class.propTypes = {
	options: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
		value: _propTypes2.default.any,
		text: _propTypes2.default.node
	})])),
	empty: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	value: _propTypes2.default.any,
	defaultValue: _propTypes2.default.any,
	onChange: _propTypes2.default.func,
	coerceValueToOptions: _propTypes2.default.bool,
	className: _propTypes2.default.string
}, _class.defaultProps = {
	options: [],
	empty: 'Please select ...',
	defaultValue: null,
	onChange: function onChange() {},
	coerceValueToOptions: true
}, _temp);
exports.default = SelectInput;